/** 
*@author: Sirisha.M
*@Description : 
**/
import _ from 'lodash';
import moment from 'moment';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { constant } from '../Utils/constants';
// import translation from '../Utils/translation';
import Highlighter from 'react-highlight-words';
import InputComponent from '../Utils/InputComponent';
import localStorage from '../../../utils/localStorage';
import SelectComponent from '../Utils/SelectComponent';
import StyledTable from '../../../commons/styles/table';
import { IPAddress,UPLOAD } from '../../../commons/api';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { DownloadOutlined, UploadOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Select,
  Modal,
  Upload,
  Checkbox
} from 'antd';
import {
  saveSubDevice,
  getAttributeList,
  getSubEquipmentFileDownloadName,
  getSubEquipmentData,
  getSubDeviceListByDeviceType
} from '../APICalls';

const SubEquipments = (props) => {
  const [formObject, setFormObject] = useState({});
  const [attributeList, setAttributeList] = useState([]);
  const [subEquipmentsList, setSubEquipmentsList] = useState([]);
  const [subdeviceTypeList, setSubdeviceTypeList] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [fileDownloadName, setFileDownloadName] = useState('');
  const [SubDeviceType, setSubDeviceType] = useState('');
  const [Status, setStatus] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchText, setSearchText] = useState('');

  const hRef = useRef();

  useEffect(() => {
    getSubEquipmentList(props.deviceDetails);
  }, [props.deviceDetails]);

  const getSubEquipmentList = async (deviceDetails) => {
    let subdeviceTypeList = await getSubDeviceListByDeviceType(deviceDetails.DeviceType);
    let SubDeviceType =
      subdeviceTypeList && subdeviceTypeList[0] ? subdeviceTypeList[0].AliasCode : '';
    let subEquipmentsList = await getSubEquipmentData(deviceDetails.DeviceCode, SubDeviceType);
    let attributeList = await getAttributeList(deviceDetails.DeviceType);

    getFileDownloadName(SubDeviceType);
    setSubEquipmentsList(subEquipmentsList);
    setSubdeviceTypeList(subdeviceTypeList);
    setAttributeList(attributeList);
    setSubDeviceType(SubDeviceType);
  };

  const translationFunc = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onFieldChange = (fieldValue, fieldName) => {
    setFormObject((prevFormObject) => ({
      ...prevFormObject,
      [fieldName]: fieldValue
    }));
  };

  const onSubEqptypeChange = async (fieldValue) => {
    let { deviceDetails } = props;
    let subEquipmentsList = await getSubEquipmentData(deviceDetails.DeviceCode, fieldValue);
    getFileDownloadName(fieldValue);
    setSubDeviceType(fieldValue);
    setSubEquipmentsList(subEquipmentsList);
  };

  const onReset = () => {
    let attKeys = {};
    attributeList.forEach(({ Code }) => Object.assign(attKeys, { [Code]: null }));

    hRef.current &&
      hRef.current.setFieldsValue({
        SubDeviceType: null,
        Name: null,
        Description: null,
        DisplayCode: null,
        UniqueCode:null,
        TableCreation: true,
        Id: null,
        ...attKeys
      });

    setFormObject({});
    setStatus(true);
  };

  const getFileDownloadName = async (SubDeviceType) => {
    let fileDownloadName = await getSubEquipmentFileDownloadName(
      props.treeValue,
      props.parent.Code,
      SubDeviceType
    );

    setFileDownloadName(fileDownloadName && fileDownloadName.file ? fileDownloadName.file : '');
  };

  const editRow = async (formObject) => {
    _.cloneDeepWith(formObject, (value) => {
      return value && value !== null && (value.ReplacementDate || value.InstallationDate || value.INSTALLATIONDATE || value.REPLACEMENTDATE)
        ? {
          ...value,
          ...(value['ReplacementDate'] = moment.utc(
            value.ReplacementDate,
            'YYYY-MM-DD HH:mm:ss'
          )),
          ...(value['InstallationDate'] = moment.utc(
            value.InstallationDate,
            'YYYY-MM-DD HH:mm:ss'
          )),
           ...(value['INSTALLATIONDATE']
                            ? (value['INSTALLATIONDATE'] = moment.utc(
                                value.INSTALLATIONDATE,
                                'YYYY-MM-DD HH:mm:ss'
                              ))
                            : null),
                          ...(value['REPLACEMENTDATE']
                            ? (value['REPLACEMENTDATE'] = moment.utc(
                                value.REPLACEMENTDATE,
                                'YYYY-MM-DD HH:mm:ss'
                              ))
                            : null),
        }
        : _.noop();
    });

    hRef.current &&
      hRef.current.setFieldsValue({
        ...formObject
      });

    setIsModalOpen(true);
    setFormObject(formObject);
    setStatus(formObject && formObject.TableCreation);
  };

  const renderWidget = (props) => {
    let { widget, Code, isEditableOnUpdate, JSON, Name } = props;

    switch (widget) {
      case 'text':
        return (
          <InputComponent
            value={
              formObject && formObject[Code]
                ? translationFunc(formObject[Code])
                : ''
            }
            placeholder={`Input ${Name}`}
            disabled={formObject.Id && isEditableOnUpdate === 'true'}
            onChange={(e) => onFieldChange(e.target.value, Code)}
          />
        );
      case 'dateselection':
        return (
          <DatePicker
            value={
              formObject && formObject[Code]
                ? moment(formObject[Code]).format('YYYY-MM-DD HH:mm:ss')
                : undefined
            }
            format={'YYYY-MM-DD HH:mm:ss'}
            allowClear={false}
            showNow={false}
            showTime={false}
            placeholder={`Select ${Name}`}
            disabled={formObject.Id && isEditableOnUpdate === 'true'}
            onChange={(e) => onFieldChange(e, Code)}
            style={{ width: '100%' }}
          />
        );
      case 'multiselect':
        return (
          <SelectComponent
            value={
              formObject && formObject[Code]
                ? formObject[Code]
                : []
            }
            placeholder={`Select ${Name}`}
            Code={props.Code || ''}
            formObject={formObject}
            api={JSON}
            DeviceType={hRef.current?.getFieldValue('DeviceType')}
            onSelectChange={(e) => onFieldChange(e, Code)}
          />
        );
      default:
        return (
          <InputComponent
            value={
              formObject && formObject[Code]
                ? translationFunc(formObject[Code])
                : ''
            }
            placeholder={`Input ${Name}`}
            disabled={formObject.Id && isEditableOnUpdate === 'true'}
            onChange={(e) => onFieldChange(e.target.value, Code)}
          />
        );
    }
  };

  // const handleOk = async () => {
  //   const siteId = localStorage.get('currentSite');
  //   let payload;

  //   try {
  //     await hRef.current.validateFields();
  //    let values = { ...hRef.current.getFieldsValue() };

  //     if (values && values.Id) {
  //       payload = {
  //         ...values,
  //         TableCreation: Status,
  //         EquipmentType: 'Child',
  //         DeviceType: props.deviceDetails?.DeviceType || '',
  //         ParentEquipment: props.deviceDetails?.AliasCode || '',
  //         AssetAlias: props.deviceDetails?.AssetAlias || '',
  //         SubDeviceType
  //       };
  //     } else {
  //       payload = {
  //         ...values,
  //         TableCreation: Status,
  //         EquipmentType: 'Child',
  //         ParentEquipment: props.deviceDetails?.AliasCode || '',
  //         DeviceType: props.deviceDetails?.DeviceType || '',
  //         AssetAlias: props.deviceDetails?.AssetAlias || '',
  //         SiteId: siteId,
  //         SubDeviceType
  //       };
  //     }

  //     if (!payload.Id) delete payload.Id;

  //     let saveResponse = await saveSubDevice(payload);

  //     if (saveResponse?.message) {
  //       message.success(saveResponse.message);

  //       let subEquipmentsList = await getSubEquipmentData(
  //         props.deviceDetails.DeviceCode,
  //         SubDeviceType
  //       );

  //       getFileDownloadName(SubDeviceType);

  //       setIsModalOpen(false);
  //       setSubEquipmentsList(subEquipmentsList);
  //     }

  //   } catch (error) { }
  // };
  const handleOk = () => {
    const siteId = localStorage.get('currentSite');
    hRef.current
      .validateFields()
      .then(async (values) => {
        let { deviceDetails } = props;
        values = {
          ...hRef.current.getFieldsValue()
        };
        let payload = {};
        if (values && values.Id) {
          // let { formObject } = this.state;
          payload = {
            ...hRef.current.getFieldsValue(),
            TableCreation: Status,
            EquipmentType: 'Child',
            DeviceType: deviceDetails && deviceDetails.DeviceType ? deviceDetails.DeviceType : '',
            ParentEquipment:
              deviceDetails && deviceDetails.AliasCode ? deviceDetails.AliasCode : '',
            AssetAlias: deviceDetails && deviceDetails.AssetAlias ? deviceDetails.AssetAlias : '',
            SubDeviceType
          };
        } else {
          payload = {
            ...hRef.current.getFieldsValue(),
            TableCreation: Status,
            EquipmentType: 'Child',
            ParentEquipment:
              deviceDetails && deviceDetails.AliasCode ? deviceDetails.AliasCode : '',
            DeviceType: deviceDetails && deviceDetails.DeviceType ? deviceDetails.DeviceType : '',
            AssetAlias: deviceDetails && deviceDetails.AssetAlias ? deviceDetails.AssetAlias : '',
            SiteId: siteId,
            SubDeviceType
          };
        }
        if (payload && (!payload.Id || payload.Id === null)) {
          delete payload.Id;
        }
        let saveResponse = await saveSubDevice(payload);
        if (saveResponse && saveResponse.message) {
          message.success(saveResponse.message);

          let subEquipmentsList = await getSubEquipmentData(
            props.deviceDetails.DeviceCode,
            SubDeviceType
          );

          this.getFileDownloadName(SubDeviceType);
          setIsModalOpen(false);
          setSubEquipmentsList(subEquipmentsList);
        }
      })
      .catch(() => { });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    onReset();
  };

  // Search and Reset Handlers

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  // Column Search Props

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => { this.searchInput = node; }}
          placeholder={translationFunc('Search')}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translationFunc('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translationFunc('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
 
  // Status Check Handler

  const onStatusCheck = (e) => {
    setStatus(e.target.checked);
  };

  // Render Logic

  const columns = [
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
      ...getColumnSearchProps('Name')
    },
    {
      title: 'Code',
      dataIndex: 'DisplayCode',
      key: 'DisplayCode',
      ...getColumnSearchProps('DisplayCode')
    },
    {
      title: 'Description',
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button onClick={() => editRow(record)}>{'Edit'}</Button>
        </span>
      )
    }
  ];

  return (
    <Fragment>
      <div style={{ display: 'flex', justifyContent: 'right', margin: '10px 0px' }}>
        <a href={`${IPAddress.LOCAL}${fileDownloadName}`}>
          <DownloadOutlined style={{ color: 'white', marginRight: '1px' }} />
          <span style={{ color: 'white', marginRight: '10px' }}>
            {translationFunc('Download')}{' '}
          </span>
        </a>
        <Upload
          multiple={false}
          style={{ marginRight: '10px', color: 'white' }}
          onChange={async (info) => {
            if (info.file.status === 'done') {
              message.success(info.file.response.message);

              let subEquipmentsList = await getSubEquipmentData(
                props.deviceDetails.DeviceCode,
                SubDeviceType
              );
              setSubEquipmentsList(subEquipmentsList);
              getFileDownloadName(SubDeviceType);
            } else if (info.file.status === 'error') {
              message.error(info.file.response.message || "Upload failed");
            }
          }}
          action={`${UPLOAD.CLIENT_Upload_Device}?SiteId=${localStorage.get('currentSite')}&DeviceType=${props.parent.Code}&EquipmentType=Child&ParentEquipment=${props.selectedRow.Code}&SubDeviceType=${SubDeviceType}`}
          headers={{
            Authorization: `Bearer ${localStorage.get('accessToken')}`
          }}
          showUploadList={false}
        >
          <UploadOutlined style={{ color: 'white', marginRight: '1px' }} />
          <span style={{ color: 'white', marginRight: '10px' }}>
            {' '}
            {translationFunc('Upload')}
          </span>
        </Upload>
        <Button type="primary" onClick={() => { setIsModalOpen(true); setStatus(true); }}>
          Add SubEquipments
        </Button>
      </div>

      <Form
        theme={themeSettings}
        layout="horizontal"
        labelCol={{ flex: '130px', marginTop: '20px' }}
        labelAlign="right"
        labelWrap
      >
        <Form.Item
          label={translationFunc(constant.SubEquipmentsType)}
          style={{ width: '50%' }}
          rules={[{ required: true, message: `Please select SubDeviceType!` }]}
        >
          <Select
            value={SubDeviceType || null}
            onChange={(e) => onSubEqptypeChange(e)}>
            {subdeviceTypeList.map((devicetype, index) => (<Select.Option key={index} value={devicetype.AliasCode}>{devicetype.Name}</Select.Option>))}
          </Select>
        </Form.Item>
      </Form>

      <StyledTable size="small"
        columns={columns}
        dataSource={Array.isArray(subEquipmentsList) ? subEquipmentsList : []}
      />

      <Modal
        width={'90%'}
        title="Add/Edit Sub equipments"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}>

        <Form
          name="DeviceForm"
          ref={hRef}
          theme={themeSettings}
          initialValues={formObject}
          layout="horizontal"
          labelCol={{ flex: '130px', marginTop: '20px' }}
          labelAlign="right"
          labelWrap>

          <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '15px' }}>
            <Form.Item name={'Id'}></Form.Item>

            {/* Sub Device Type */}
            <Form.Item
              label={translationFunc(constant.SubEquipmentsType)}
              style={{ width: '50%' }}
              rules={[{ required: false, message: `Please select SubDeviceType!` }]}>
              <Select value={SubDeviceType} disabled placeholder={constant.SubEquipmentsType}>
                {subdeviceTypeList.map((devicetype, index) => (<Select.Option key={index} value={devicetype.Code}>{devicetype.Name}</Select.Option>))}
              </Select>
            </Form.Item>

            {/* Name */}
            <Form.Item
              name="Name"
              label={translationFunc(constant.Name)}
              style={{ width: '50%' }}
              rules={[{ required: true, message: `Please enter name!` }]}>
              <InputComponent placeholder={`Input ${constant.Name}`} value={formObject.Name ? translationFunc(formObject.Name) : ''} />
            </Form.Item>

            {/* Description */}
            <Form.Item
              name="Description"
              label={translationFunc(constant.Description)}
              style={{ width: '50%' }}
              rules={[{ required: true, message: `Please enter Description!` }]}>
              <Input.TextArea placeholder={`Input ${constant.Description}`} value={formObject.Description ? translationFunc(formObject.Description) : ''} />
            </Form.Item>

            {/* Display Code */}
            <Form.Item
              name="DisplayCode"
              label={translationFunc(constant.DisplayCode)}
              style={{ width: '50%' }}
              rules={[{ required: true, message: `Please enter code!` }]}>
              <InputComponent placeholder={`Input ${constant.Code}`} value={formObject.DisplayCode ? translationFunc(formObject.DisplayCode) : ''} />
            </Form.Item>
            <Form.Item
                  name="UniqueCode"
                  style={{ width: '50%' }}
                  label={translationFunc( constant.Code)}
                  rules={[
                    {
                      required: true,
                      message: 'Please input Code!'
                    }
                  ]}
                >
                  <InputComponent
                    disabled={formObject.Id}
                    placeholder="Input Code!"
                    value={
                      formObject && formObject.UniqueCode
                        ? translationFunc(formObject.UniqueCode)
                        : ''
                    }
                  />
                </Form.Item>
            {/* Dynamic Attributes */}
            {attributeList.map((attr, index) => {
              let requiredField = attr.mandatory === 'Optional' ? false : true;
              return (
                <Form.Item key={index} name={attr.Code} label={translationFunc(attr.Name)} style={{ width: '50%' }} rules={[{ required: requiredField, message: `Please enter ${attr.Name}!` }]}>{renderWidget(attr)}</Form.Item>
              );
            })}

            {/* Table Creation Checkbox */}
            <Form.Item name="TableCreation" label={translationFunc(constant.TableCreation)} style={{ width: '50%' }}>
              <Checkbox disabled={(formObject.TableCreation === true)} checked={Status} onChange={onStatusCheck}></Checkbox>
            </Form.Item>

          </div>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default SubEquipments;
